import React from 'react';
import { Typography } from '@kistech/kis-ui';
import { Requirements } from './VideoMediaList/VideoRequirements';
import { MediaTypes } from '../../types';

interface MediaProps {
  mediaType: MediaTypes;
}

const getMediaText = (mediaType: MediaTypes) => {
  let mediaText = '';
  switch (mediaType) {
    case MediaTypes.ATTRACT_IMAGE:
      mediaText = 'Select an image for your attract loop.';
      break;
    case MediaTypes.ATTRACT_VIDEO:
      mediaText = 'Select a video for your attract loop.';
      break;
    case MediaTypes.UPPER_IMAGE:
      mediaText = 'Add one or more images to your slideshow';
      break;
    case MediaTypes.UPPER_VIDEO:
      mediaText = 'Upload a video to the kiosk upper deck';
      break;
    case MediaTypes.LINKED_CONTENT:
      mediaText = 'Enter the URL to your linked content';
      break;
    default:
      mediaText = 'Select a media';
  }

  return mediaText;
};

export const MediaText = (props: MediaProps) => (
  <>
    <Typography size={18} weight={400}>
      {getMediaText(props.mediaType)}
    </Typography>
    {props.mediaType === MediaTypes.ATTRACT_VIDEO || props.mediaType === MediaTypes.UPPER_VIDEO ? (
      <Requirements />
    ) : null}
  </>
);
